import React from "react";
import "./toggleButton.scss";

export const ToggleButton = ({ key,onToggle, selected, title = "" }) => (
	<label className="switch">
		<input type="checkbox" checked={selected} onChange={onToggle} />
		<span className="slider round" title={title} key={key ?key :null}></span>
	</label>
);
